// extracted by mini-css-extract-plugin
export default {"heroHeader":"FairmontFashion_heroHeader__0na7a","adj1":"FairmontFashion_adj1__JEGue","adj2":"FairmontFashion_adj2__m9F73"};